// eslint-disable-next-line no-undef
export const savedJQuery = $

/**
 * @param {string} selector 
 */
export function modal (selector) {
  savedJQuery(selector).modal()
}